import '../account_settings/user_profile_attributes/user_profile_attribute.js.coffee'

Namespace 'Profile.UserProfile'

class Profile.UserProfile.UserProfile extends Backbone.Model
  defaults:
    account_id: 0
    created_at: '2019-01-01T00:00:00-00:00'
    updated_at: '2019-01-01T00:00:00-00:00'
    description: ''
    last_customer_response: null
    social_users: ['']
    tags: ['']
    values: {}

class Profile.UserProfile.ExtendedUserProfile extends Backbone.Model
  defaults:
    profile: new Profile.UserProfile.UserProfile
    social_users: new Models.SocialUserCollection
    editable_attributes: new AccountSettings.UserProfileAttributeCollection
    tickets: []
    externalTickets: []

  initialize: ->
    @set('profile', new Profile.UserProfile.UserProfile(@get('profile')))
    @set('social_users', new Models.SocialUserCollection(@get('social_users')))
    @set('editable_attributes', new AccountSettings.UserProfileAttributeCollection(@get('editable_attributes')))

  mainSocialUser: =>
    @get('social_users').at(0)

  getByTicket: (ticket) ->
    _activeParticipants = encodeURIComponent(ticket.activeParticipants())
    $.ajax
      type: 'GET'
      url: "/profiles/api/#{@_sourceFromTicket(ticket)}/#{_activeParticipants}"
      success: (response) =>
        @set('profile', new Profile.UserProfile.UserProfile(response.profile))
      error: (error) -> alert(JSON.stringify(error))

  getExternalTickets: ->
    return [] unless @get('profile').get('values').multiple_sky_chile_external_ticket

    @get('profile').get('values').multiple_sky_chile_external_ticket.map((json) -> json.value.json)

  _sourceFromTicket: (ticket) ->
    return ticket.type() if ticket.hasActiveParticipants()
    notResponses = _.filter(ticket.allInteractions(), (i) -> !i.isResponseFromClient())[0]
    interaction = notResponses[0] || ticket.allInteractions[0]
    interaction.type()

class Profile.UserProfile.MergeCandidateCollection extends Backbone.Collection
  model: Profile.UserProfile.ExtendedUserProfile

  initialize: (models, {source, social_network_id}) ->
    @source = source
    @social_network_id = social_network_id

  url: =>
    "/profiles/api/#{@source}/#{@social_network_id}/candidates"
